import { ibkApi } from '@ibk/shared-config';
import { parsePdfResponse } from './pdfResponseParser';
export const buildGenerateOrderReceiptPdfMutation = ({ contractId, orderId, }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/payment-receipt/pdf`,
    method: 'POST',
    responseHandler: parsePdfResponse,
});
export const contractOrderReceiptApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        generateEmissorOrderReceiptPdf: build.mutation({
            query: buildGenerateOrderReceiptPdfMutation,
        }),
    }),
    overrideExisting: false,
});
export const { useGenerateEmissorOrderReceiptPdfMutation } = contractOrderReceiptApi;
